<template>
  <div>
    <v-container fluid class="mx-12 my-6">
      <div class="d-flex flex-row mb-4">
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-cash-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Preview Units</p>
        </div>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              rounded
              color="primary"
              class="mr-2 font-weight-bold"
              @click="openImportFile"
              v-on="on"
            >
              <v-icon class="pr-1">mdi-file-upload</v-icon>Import New File
            </v-btn>
          </template>
          <p style="color: white">
            Create and import units by uploading a YAML File
          </p>
        </v-tooltip>
      </div>
      <v-card elevation="0" class="card-container px-8 py-4">
        <v-treeview
          v-if="entries.length"
          open-all
          :items="entries"
          item-key="id"
          dense
          hoverable
        >
          <template v-slot:prepend="{ item }">
            <v-icon v-if="!item.children" small> mdi-grain </v-icon>
          </template>
          <template v-slot:append="{ item }">
            <div v-if="item.metadata">
              <v-chip
                v-for="key in Object.keys(item.metadata)"
                :key="key"
                class="mx-1"
                color="primary"
                label
                outlined
                small
              >
                <v-icon color="primary" small left> mdi-label </v-icon>
                {{ key }}: {{ item.metadata[key] }}
              </v-chip>
            </div>
          </template>
        </v-treeview>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            :disabled="!entries.length"
            @click="finish"
            >Begin import</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
    <ImportUnitsFileUpload
      ref="importUnitsFileUpload"
      :reload-data="reloadData"
    ></ImportUnitsFileUpload>
  </div>
</template>

<script>
import ImportUnitsFileUpload from '../components/property/ImportUnitsFileUpload.vue'
export default {
  components: {
    ImportUnitsFileUpload
  },
  data() {
    return {
      entries: []
    }
  },
  methods: {
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    openImportFile() {
      this.$refs.importUnitsFileUpload.open()
    },
    async finish() {
      if (
        await this.$root.$confirm({
          message: `Are you sure you want to create the groups and units?`,
          confirmText: 'Yes',
          options: {
            width: 400
          }
        })
      ) {
        this.$root.$setLoading(true)
        try {
          const result = await this.$store.dispatch(
            'units/submitBatchUnitImportEntries',
            {
              data: this.entries
            }
          )
          if (result) {
            this.$root.$setLoading(false)
            this.$root
              .$confirm({
                title: 'Import Units',
                message: `Successfully created units`,
                reconfirmOnly: true,
                confirmText: 'OK',
                options: {
                  color: 'primary'
                }
              })
              .then(() => {
                this.$router.replace('/units')
              })
          } else {
            this.showErrorDialog()
          }
        } catch (err) {
          this.showErrorDialog()
        }
      }
    },
    cancel() {
      this.$router.replace('/property')
    },
    reloadData() {
      this.entries = this.$store.getters['units/getBatchUnitsImportPreview']
    },
    showErrorDialog() {
      this.$root.$setLoading(false)
      this.$root.$confirm({
        title: 'Import Units',
        message: `There was an error creating units`,
        reconfirmOnly: true,
        confirmText: 'OK',
        options: {
          color: 'error'
        }
      })
    }
  }
}
</script>
